import { useChatProfileShallowSelector } from 'components/AskDelaChat/ChatProfileStore'
import { useSuggestionsShallowSelector } from 'components/WorkspaceEditor/SuggestionStore'
import { usePromoteDemoteStore } from 'components/WorkspaceEditor/features/promoteDemote/store/PromoteDemoteStore'
import { useMemo } from 'react'

/**
 * A custom hook to determine if actions should be disabled based on the user's role or processing state.
 * @returns {boolean} A boolean indicating whether actions should be disabled.
 */
export function useShouldDisableActions(): boolean {
    const role = useChatProfileShallowSelector((state) => state.chatUser?.role)
    const { isAnyTrackChangeProcessing } = useSuggestionsShallowSelector((state) => ({
        isAnyTrackChangeProcessing: state.isAnyTrackChangeProcessing,
    }))
    const isPromoteDemoteInFlight = usePromoteDemoteStore((state) => state.isPromoteDemoteInFlight)

    return useMemo(() => {
        if (role === 'Reviewer') return true
        if (isAnyTrackChangeProcessing) return true
        if (isPromoteDemoteInFlight) return true
        return false
    }, [role, isAnyTrackChangeProcessing, isPromoteDemoteInFlight])
}
